import { atom } from 'jotai';
import type { BufferedEventJournaler } from '../event-journal/buffered-event-journaler';
import type { EventJournalConsumer } from '../event-journal/event-journal-consumer';
import type { PersistenceOrchestrator } from '../event-journal/persistence-orchestrator';
export const eventJournalerAtom = atom<BufferedEventJournaler | null>(null);
export const eventJournalConsumerAtom = atom<EventJournalConsumer | null>(null);
export const persistenceOrchestratorAtom = atom<PersistenceOrchestrator | null>(null);